import { useCallback } from 'react';
import { useBroadcastChannel } from '../../../utils/hooks';
import Cognito from '../utils/Cognito';
import { useLocation, useNavigate } from 'react-router-dom';
import useBroadcastIframe from '../../../utils/hooks/useBroadcastIframe';

export default () => {
  const navigate = useNavigate();
  const location = useLocation();

  // message handler must be stable reference, otherwise it causes effect
  // in useBroadcastChannel on every rerender
  const performLogout = useCallback(() => {
    Cognito.setRedirectUrl(location.pathname);
    Cognito.logout().finally(() => {
      setTimeout(() => navigate(Cognito.getLoginPageUrl()), 300);
    });
  }, [location, navigate]);

  const { broadcast } = useBroadcastChannel({
    channelName: 'logout',
    messageHandler: performLogout,
  });

  const { broadcast: broadcastIframe } = useBroadcastIframe({
    messageType: 'logout',
    messageHandler: performLogout,
  });

  return useCallback(() => {
    broadcast('logout');
    broadcastIframe('logout');
    performLogout();
  }, [broadcast, broadcastIframe, performLogout]);
};
